/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var BrowserDetect = {
      init: function () {
          this.browser = this.searchString(this.dataBrowser) || "Other";
          this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
      },
      searchString: function (data) {
          for (var i = 0; i < data.length; i++) {
              var dataString = data[i].string;
              this.versionSearchString = data[i].subString;

              if (dataString.indexOf(data[i].subString) !== -1) {
                  return data[i].identity;
              }
          }
      },
      searchVersion: function (dataString) {
          var index = dataString.indexOf(this.versionSearchString);
          if (index === -1) {
              return;
          }

          var rv = dataString.indexOf("rv:");
          if (this.versionSearchString === "Trident" && rv !== -1) {
              return parseFloat(dataString.substring(rv + 3));
          } else {
              return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
          }
      },

      dataBrowser: [
          {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"},
          {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
          {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
          {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
          {string: navigator.userAgent, subString: "Safari", identity: "Safari"},
          {string: navigator.userAgent, subString: "Opera", identity: "Opera"}
      ]

  };

BrowserDetect.init();

function waitForWebfonts(fonts, callback) {
    var loadedFonts = 0;
    for(var i = 0, l = fonts.length; i < l; ++i) {
        (function(font) {
            var node = document.createElement('span');
            // Characters that vary significantly among different fonts
            node.innerHTML = 'giItT1WQy@!-/#';
            // Visible - so we can measure it - but not on the screen
            node.style.position      = 'absolute';
            node.style.left          = '-10000px';
            node.style.top           = '-10000px';
            // Large font size makes even subtle changes obvious
            node.style.fontSize      = '300px';
            // Reset any font properties
            node.style.fontFamily    = 'sans-serif';
            node.style.fontVariant   = 'normal';
            node.style.fontStyle     = 'normal';
            node.style.fontWeight    = 'normal';
            node.style.letterSpacing = '0';
            document.body.appendChild(node);

            // Remember width with no applied web font
            var width = node.offsetWidth;

            node.style.fontFamily = font + ', sans-serif';

            var interval;
            function checkFont() {
                // Compare current width with original width
                if(node && node.offsetWidth !== width) {
                    ++loadedFonts;
                    node.parentNode.removeChild(node);
                    node = null;
                }

                // If all fonts have been loaded
                if(loadedFonts >= fonts.length) {
                    if(interval) {
                        clearInterval(interval);
                    }
                    if(loadedFonts === fonts.length) {
                        callback();
                        return true;
                    }
                }
            }

            if(!checkFont()) {
                interval = setInterval(checkFont, 50);
            }
        })(fonts[i]);
    }
}


if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function() {


        
        waitForWebfonts(['Revelstoke-Regular'], function() {
          jQuery('body').addClass('DOMContentLoaded');
        });

        FastClick.attach(document.body);

            var feed = new Instafeed({
                get: 'user',
                userId: '4215055596',
                accessToken: '4215055596.c0c61b7.d4a17473d36a430daf5c9a16ccf43526',
                clientId: 'c0c61b750ef842209d328e7e4e7bc5b6',
                limit: 10,
                template: '<a class="instafeed-link" href="{{link}}"><img src="{{image}}" /></a>'
                
            });
            feed.run();


            var gmapScript ='https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyBfGaedmcEpkFlXK6LSgpyN-DTsreLB-I8';
            if(jQuery("#map-canvas").length !== 0){
              jQuery.getScript( gmapScript )
                .done(function( script, textStatus ) {
                    var lat = 49.54964;
                    var lng = -124.691424;
                    

                    console.log("Lat: " + lat);
                    console.log("Lng: " + lng);

                    //Start off the Google Maps
                    var myLatlng = new google.maps.LatLng(lat, lng);
                    
                    var mapOptions = {
                      zoom: 14,
                      center: myLatlng,
                      //panControl: false,
                      //zoomControl: false,
                      //scaleControl: false,
                      scrollwheel: false, 
                      mapTypeId: 'satellite'
                      //disableDefaultUI: true,
                      //styles:[{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}]

                    };
                    map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);


                    
                      // Add the sales center marker
                      var icon = {
                        path: 'M19.4,0C8.7,0,0,8.7,0,19.4c0,14.9,19.4,32.8,19.4,39.2c-0.1-6.3,19.4-24.4,19.4-39.2C38.7,8.7,30,0,19.4,0z M19.4,27.1c-4.1,0-7.3-3.3-7.3-7.3c0-4.1,3.3-7.3,7.3-7.3c4.1,0,7.3,3.3,7.3,7.3C26.7,23.9,23.4,27.1,19.4,27.1z',
                        fillColor: '#ffffff',
                        fillOpacity: 1,
                        scale: 1,
                        strokeWeight: 0,
                        size: new google.maps.Size(11, 22),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(20, 50)
                      };
                      /**
                      * If you need to use an image
                      * Must know the size of the image, and then scale that image down for retina use
                      */
                      // var icon = {
                      //   url:'PATH TO PIN',
                      //   size: new google.maps.Size(47,80),
                      //   scaledSize: new google.maps.Size(31.333333333, 53.333333333), 
                      //   origin: new google.maps.Point(0, 0),
                      //   anchor: new google.maps.Point(15.66665, 26.66665)
                      // };
                

                        popupContent = "<h4>Fossil Beach Farm LTD</h4><p style='line-height: 1.25em;'>750 Savoie Road, <br />Hornby Island, BC, <br />V0R 1Z0</p>";
                        var marker = new google.maps.Marker({
                          position: myLatlng,
                          map: map,
                          icon: icon,
                          animation: google.maps.Animation.DROP
                        });

                        var infowindow = new google.maps.InfoWindow({
                          content: popupContent,
                          size: new google.maps.Size(150, 50)
                        });
                        
                        google.maps.event.addListener(marker, 'click', (function(marker) {
                          return function() {
                            infowindow.setContent(popupContent);
                            infowindow.open(map, marker);
                          };
                        })(marker));

                })
                .fail(function( jqxhr, settings, exception ) {
                  //$( "div.log" ).text( "Triggered ajaxError handler." );
              });
            }


    }, false);


}

Modernizr.addTest('svgasimg', document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1'));


// Do things

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      

      },
      finalize: function() {

      }
    },
    // All pages
    'borderland': {
      init: function() {
        // JavaScript to be fired on all pages
      

      },
      finalize: function() {
       
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page;

      },
      finalize: function() {

      }
    },
    // About us page, note the change from about-us to about_us.
    'not_front': {
      init: function() {
        // JavaScript to be fired on the about us page
      

      }
    },
    'our_team': {
      init: function() {

      },
       finalize: function() {

       }
    },
    'contact': {
      init: function() {

      },
       finalize: function() {
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');
        // Fire page-specific init JS, and then finalize JS
        $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
          UTIL.fire(classnm);
          setTimeout(function(){
            UTIL.fire(classnm, 'finalize');
          },200);
        });
        // Fire common finalize JS
        setTimeout(function(){
          UTIL.fire('common', 'finalize');
          console.info( "main.js file has fired all commands." );
        },200);

    }
  };


})(jQuery); // Fully reference jQuery after this point.
